export default class GroupedController {
    static $inject = ['$scope','$element','$compile'];
    constructor($scope, $element, $compile) {
        'ngInject';
        this.$scope = $scope;
        this.$element = $element;
        this.$compile = $compile;
        this.options = {
            responsive: false,
            maintainAspectRatio: false,
            scaleShowGridLines: true,
            scaleGridLineColor: "rgba(0,0,0,.05)",
            scaleGridLineWidth: 1,
            bezierCurve: true,
            bezierCurveTension: 1,
            pointDot: true,
            pointDotRadius: 5,
            pointDotStrokeWidth: 1,
            pointHitDetectionRadius: 20,
            datasetStroke: true,
            datasetStrokeWidth: 3,
            datasetFill: false,
            scales: {
                yAxes: [{
                    stacked: true,
                    scaleLabel: {
                        display: true,
                        labelString: this.ylabel
                    },
                    ticks: {
                        beginAtZero: true
                    }
                }],
                xAxes: [{
                    stacked: true,
                    barPercentage: 0.4,
                    scaleLabel: {
                        display: true,
                        labelString: this.xlabel
                    },
                    gridLines: {
                        display:true,
                        offsetGridLines: true
                    }
                }]
            },
            legend: {
                display: false,
                position: 'right',
                onClick: function (e, item) {
                    const chart = this.chart;
                    this.chart.data.datasets.forEach((d, i) => {
                        if (d.stack === item.text) {
                            const meta = chart.getDatasetMeta(i);
                            meta.hidden = !meta.hidden;
                            item.hidden = meta.hidden;
                            item.hidden = !chart.isDatasetVisible(i);
                        }
                    });
                    chart.update();
                },
                labels: {
                    boxWidth: 12,
                    generateLabels: chart => {
                        return this.data.override.map((o, i) => ({
                            text: o.stack,
                            fillStyle: `rgba(${o.color.r}, ${o.color.g}, ${o.color.b}, 0.6)`,
                            strokeStyle: `rgba(${o.color.r}, ${o.color.g}, ${o.color.b}, 0.8)`,
                            hidden: !chart.isDatasetVisible(i)
                        })).reduce((acc, val) => {
                            if (!acc.some(a => a.text === val.text)) {
                                return [...acc, val];
                            }
                            return acc;
                        }, []);
                    }
                }
            },
            tooltips: {
                intersect: false,
                position: 'average',
                mode: 'point'
            },
            title: {
                display: true,
                text: this.title,
                lineHeight: '1'
            },
            legendCallback: chart => {
                const list = this.data.override.map((o, i) => {
                    if (this.excludedItems.indexOf(o.stack) !== -1) {
                        const meta = chart.getDatasetMeta(i);
                        meta.hidden = true;
                    }

                    return {
                        text: o.stack,
                        fillStyle: `rgba(${o.color.r}, ${o.color.g}, ${o.color.b}, 0.6)`,
                        strokeStyle: `rgba(${o.color.r}, ${o.color.g}, ${o.color.b}, 0.8)`,
                        hidden: !chart.isDatasetVisible(i)
                    };
                }).reduce((acc, val) => {
                    if (!acc.some(a => a.text === val.text)) {
                        return [...acc, val];
                    }
                    return acc;
                }, []);
                chart.update();

                const lis = list.map((d, index) => `<li ${d.hidden ? 'class="removed"' : ''} data-item="${d.text}" data-ng-click="$ctrl.onLegendItemClick($event, '${d.text}')" title="${d.text}"><span style="border-color: ${d.strokeStyle}; background-color: ${d.strokeStyle}"></span> ${d.text}</li>`);
                return `<ul>${lis.join('')}</ul>`;
            }
        };
    }

    $onInit() {
        this.calculateStyles(this.height);
        this.unwatchHeight = this.$scope.$watch(() => this.height, (newValue, oldValue) => {
            if (newValue && newValue !== oldValue) {
                this.calculateStyles(newValue);
            }
        });
        this.unwatchTitle = this.$scope.$watch(() => this.title, (newValue, oldValue) => {
            this.options.title.text = newValue;
        });
        this.$scope.$on('chart-create', (e, chart) => {
            this.chart = chart;
            const legend = this.$compile(chart.generateLegend())(this.$scope);
            this.$element.find('.legend-container').html(legend);
        });
    }

    $onDestroy() {
        this.unwatchHeight();
        this.unwatchTitle();
    }

    calculateStyles(height) {
        this.wrapperStyle = { 'max-height': `${height}px` };
        this.boxStyle = { height: `${height - 60}px` };
        this.legendStyle = { height: `${height - 70}px` };
    }

    onLegendItemClick(e, stack) {
        const target = e.target.nodeName === 'LI' ? e.target : e.target.parentNode;
        this.chart.data.datasets.forEach((d, i) => {
            if (d.stack === stack) {
                const meta = this.chart.getDatasetMeta(i);
                meta.hidden = !meta.hidden;
                if (meta.hidden) {
                    target.classList.add('removed');
                } else {
                    target.classList.remove('removed');
                }
            }
        });
        this.onLegendItemToggle(target.dataset.item);
        this.chart.update();
    }
}



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/components/graphs/grouped/grouped.controller.js